
import Vue, { CreateElement } from 'vue';
import {VLayout, VFlex, VIcon, VBtn, VDivider, VProgressLinear, VProgressCircular} from 'vuetify/lib';


/**
 * Componente que muestra en pantalla completa un JumboPanel: mensaje junto con una descripcion y un boton para realizar una accion.
 *
 * Usarlo cuando el mensaje debe mostrarse en primer plano (ocultando todo lo demas).
 */
export default Vue.extend({
    functional: true,
    props: {
        /** Altura minima en px */
        minHeight: {default: '400'},
        /** Icono a mostrar */
        icon: String,
        title: String,
        message: String,
        /** Mostrar inicialmente un brillo en el boton para que llame la atencion */
        buttonShine: { type: Boolean, default: true },
        /** No mostrar el boton */
        buttonHide: Boolean,
        buttonColor: { default: 'blue darken-1' },
        buttonLabel: { default: 'Aceptar' },
        buttonIcon: { required: false }
    },
    // tslint:disable-next-line:variable-name
    render(_h: CreateElement, ctx) {
        const buttonTextColor = getTextClassForColor(ctx.props.buttonColor);

        const buttonClick = ctx.listeners.click || function() {};

        return (
            <VContainer fill-height style= {ctx.props.minHeight ? `min-height: ${ctx.props.minHeight}px` : ''}
                        class= {(ctx.data.class || '') + ' ' + (ctx.data.staticClass || '')}>
                <VLayout align-center justify-center>
                    <VFlex text-xs-center>
                        <VIcon size= '70'>{ctx.props.icon}</VIcon>
                        <h3 class= 'display-2 thin-text'>{ctx.props.title}</h3>

                        <VDivider class= 'my-3' />

                        <div class= 'title mb-3 thin-text'>{ctx.slots().default || ctx.props.message}</div>

                        {!ctx.props.buttonHide && <VBtn
                            class={`mt-3 mx-0 btn-panel ${buttonTextColor} ${(ctx.props.buttonShine ? 'btn-shine' : '')}`}
                            large dark
                            color={ctx.props.buttonColor || 'blue darken-1'}
                            onClick={buttonClick}>
                            <h3>
                                {ctx.props.buttonIcon ? <VIcon class= 'mr-2'>{ctx.props.buttonIcon}</VIcon> : null}
                                {ctx.props.buttonLabel || 'Aceptar'}
                            </h3>
                        </VBtn>}
                    </VFlex>
                </VLayout>
            </VContainer>
        );
    }
});

function getTextClassForColor(color: string) {
    if (color.startsWith('#')) return color;
    const parts = color.split(' ');
    let result = parts[0] + '--text';
    if (parts.length > 1) result += ' text--' + parts[1];
    return result;
}

